import { useState } from "react";
import { IconButton, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Button from "@mui/material/Button";
import { useTranslate } from "../../../../../hooks/useTranslate";
import Chip from "../../../../../components/Chip";
import { getCountryDialCode, parseCountryDialCode } from "../../../../../constants/countryCodes";
import BaseDialog from "../../../../../components/BaseDialog";
import useVerificationStatus from "../../../../../context/status/useStatuses";
import "./ContactShortInfo.css";
import VerificationStatusChip from "../../../../../components/VerificationStatusChip";
import { applicantStatusHelper } from "../../../../../helpers/applicant.status.helper";

const ContactShortInfo = (props) => {
    const {
        contact, relationships,
        isActionsDisabled, isPrimaryContact, isDeletingContact,
        onEditClick, onDelete,
    } = props;
    const { t } = useTranslate();
    const { primaryContactVerificationKey } = useVerificationStatus();

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const isDetailsStatusComplete = applicantStatusHelper.hasContactFullDetails(contact);
    const detailsStatus = {
        statusTextKey: isDetailsStatusComplete ? 'status.detailsComplete' : 'status.detailsIncomplete',
        isSuccess: isDetailsStatusComplete,
        isWarning: !isDetailsStatusComplete,
    };

    const contactFullName = `${contact.title} ${contact.forename} ${contact.surname}`;
    const relation = relationships.find((relation) => relation.value === contact.relationshipTypeId)?.label;
    const students = contact.students.filter((student) => student.isResponsible).map((student) => `${student.studentFirstName} ${student.studentLastName}`).join(" | ");

    return (
        <>
            <div className="contact-short-info">
                <div className="contact-short-info__header">
                    <Typography variant="h4" component="div" className="contact-short-info__title">
                        {contactFullName}
                    </Typography>
                    <div className="contact-short-info__header-right-slot">
                        <IconButton
                            aria-label="edit"
                            className="contact-short-info__action-icon"
                            disableRipple
                            onClick={onEditClick}
                            disabled={isActionsDisabled}
                        >
                            <EditOutlinedIcon />
                        </IconButton>
                        {/* <IconButton
                            aria-label="delete"
                            className="contact-short-info__action-icon"
                            disableRipple
                            disabled={isActionsDisabled || isPrimaryContact}
                            onClick={() => setShowDeleteDialog(true)}
                        >
                            <DeleteOutlinedIcon />
                        </IconButton> */}
                    </div>
                </div>
                <div className="contact-short-info__content mt-2">
                    <div>
                        <Typography variant="h4" component="div" className="contact-short-info__main">
                            {`${relation ? `${relation} - ` : ''}${t("responsibleAdults.responsibleFor")} `}
                            <b>{students}</b>
                        </Typography>
                        <Typography variant="body1" component="div" className="contact-short-info__secondary">
                            {contact.primaryPhone?.number && (
                                <span>
                                    {`${t("responsibleAdults.tel")} ${contact.primaryPhone.countryCode ? `${getCountryDialCode(contact.primaryPhone.countryCode)} ${contact.primaryPhone.number}` : parseCountryDialCode(contact.primaryPhone.number)}`}
                                </span>
                            )}
                            {contact.emailAddress && (
                                <span>
                                    {`${t("responsibleAdults.email")} ${contact.emailAddress}`}
                                </span>
                            )}
                        </Typography>
                    </div>
                    <div className="flex flex-column gap-2">
                        <VerificationStatusChip status={detailsStatus} />
                        {isPrimaryContact && (
                            <VerificationStatusChip status={primaryContactVerificationKey} />
                        )}
                    </div>
                </div>
            </div>
            <BaseDialog
                open={showDeleteDialog}
                onClose={() => setShowDeleteDialog(false)}
                title={t("responsibleAdults.deleteDialogTitle", { contactName: contactFullName })}
            >
                <div className="flex align-center gap-8">
                    <Button
                        variant="outlined"
                        className="contact-information-form__button"
                        onClick={() => setShowDeleteDialog(false)}
                        disabled={isDeletingContact}
                    >
                        {t("button.back")}
                    </Button>
                    <Button
                        variant="contained"
                        className="button-accent contact-information-form__button"
                        onClick={onDelete}
                        loading={isDeletingContact}
                    >
                        {t("button.delete")}
                    </Button>
                </div>
            </BaseDialog>
        </>
    );
};

export default ContactShortInfo;
